/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserImportItem } from './UserImportItem';
import {
    UserImportItemFromJSON,
    UserImportItemFromJSONTyped,
    UserImportItemToJSON,
    UserImportItemToJSONTyped,
} from './UserImportItem';

/**
 * Bulk import request: parsed user rows plus a shared initial password.
 * @export
 * @interface UserImportRequest
 */
export interface UserImportRequest {
    /**
     * 
     * @type {Array<UserImportItem>}
     * @memberof UserImportRequest
     */
    items: Array<UserImportItem>;
    /**
     * Initial password assigned to every imported user
     * @type {string}
     * @memberof UserImportRequest
     */
    password: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserImportRequest
     */
    role_ids?: Array<number> | null;
}

/**
 * Check if a given object implements the UserImportRequest interface.
 */
export function instanceOfUserImportRequest(value: object): value is UserImportRequest {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function UserImportRequestFromJSON(json: any): UserImportRequest {
    return UserImportRequestFromJSONTyped(json, false);
}

export function UserImportRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserImportRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(UserImportItemFromJSON)),
        'password': json['password'],
        'role_ids': json['role_ids'] == null ? undefined : json['role_ids'],
    };
}

export function UserImportRequestToJSON(json: any): UserImportRequest {
    return UserImportRequestToJSONTyped(json, false);
}

export function UserImportRequestToJSONTyped(value?: UserImportRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(UserImportItemToJSON)),
        'password': value['password'],
        'role_ids': value['role_ids'],
    };
}

